import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.document-management')
  .factory('$pdfFormTemplates', pdfFormTemplatesObjectFactory);

/* @ngInject */
function pdfFormTemplatesObjectFactory($bringozFactory: $bringozFactory,
                                       PdfFormTemplates_DS: DataStoreConfig,
                                       PdfFormTemplatesAPI: BringozApi) {

  function $pdfFormTemplates(id: string) {
    return $bringozFactory(id, PdfFormTemplatesAPI, PdfFormTemplates_DS)
  }

  return $pdfFormTemplates
}
